/**
 * @generated SignedSource<<8c3fae941a647d158e35abe1254fb31d>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventCreated_job$fragmentType: FragmentType;
export type JobEventCreated_job$data = {|
  +agentQueryRules: ?$ReadOnlyArray<string>,
  +cluster: ?{|
    +name: string,
    +organization: ?{|
      +slug: string,
    |},
    +uuid: string,
  |},
  +clusterQueue: ?{|
    +cluster: ?{|
      +name: string,
      +organization: ?{|
        +slug: string,
      |},
      +uuid: string,
    |},
    +dispatchPaused: boolean,
    +dispatchPausedAt: ?any,
    +dispatchPausedBy: ?{|
      +name: string,
    |},
    +dispatchPausedNote: ?string,
    +key: string,
    +uuid: string,
  |},
  +concurrency: ?{|
    +group: string,
    +limit: number,
  |},
  +createdAt: ?any,
  +matrix: ?any,
  +priority: {|
    +number: ?number,
  |},
  +step: ?{|
    +conditional: ?string,
    +dependencies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +key: ?string,
          +uuid: string,
        |},
      |}>,
    |},
    +key: ?string,
    +uuid: string,
  |},
  +uuid: string,
  +$fragmentType: JobEventCreated_job$fragmentType,
|};
export type JobEventCreated_job$key = {
  +$data?: JobEventCreated_job$data,
  +$fragmentSpreads: JobEventCreated_job$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Cluster",
  "kind": "LinkedField",
  "name": "cluster",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventCreated_job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agentQueryRules",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "kind": "LinkedField",
      "name": "clusterQueue",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPaused",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPausedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "dispatchPausedBy",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPausedNote",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobConcurrency",
      "kind": "LinkedField",
      "name": "concurrency",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "group",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "limit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matrix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StepCommand",
      "kind": "LinkedField",
      "name": "step",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conditional",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "DependencyConnection",
          "kind": "LinkedField",
          "name": "dependencies",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DependencyEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Dependency",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "dependencies(first:10)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobTypeCommand",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "031dad4b8bb009b4821b4e6f1e37f5ef";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventCreated_job$fragmentType,
  JobEventCreated_job$data,
>*/);
